import { MutateCoachForm } from '@/features/coach/schema/mutate-coach-schema';
import { CoachDoc } from '@/features/home/services/get-coach';
import { getCurrentEnvUrls } from '@/libs/config';
import { WithId } from '@/libs/firebase/firestore';
import type { Address } from '@/types';
import { getCountryName, resolveAddressLocation } from '@/utils/address-location';
import parsePhoneNumberFromString, { AsYouType, isPossiblePhoneNumber } from 'libphonenumber-js';

export const convertCoachDocToMutateCoachForm = (coach: WithId<CoachDoc>): MutateCoachForm => {
  const baseUrl = getCurrentEnvUrls().pictureUrl?.trim() || undefined;
  const inferredAvatarUri = baseUrl
    ? `${baseUrl}${coach.id}.jpg?alt=media&updated_at=${coach.updated_at}`
    : undefined;

  const normalizedPhone = coach.phone?.startsWith('+') ? coach.phone : `+1${coach.phone ?? ''}`;

  const formatterPhone = new AsYouType();
  const formattedPhone = formatterPhone.input(`${normalizedPhone}`);

  const possiblePhone = isPossiblePhoneNumber(`${normalizedPhone}`);
  const phoneNumberParse = possiblePhone
    ? parsePhoneNumberFromString(`${normalizedPhone}`)
    : undefined;
  const location = resolveAddressLocation(coach.address?.country, coach.address?.state);

  return {
    phoneNumber: formattedPhone,
    countryCode: phoneNumberParse?.country ?? 'US',
    country: location.country,
    city: coach?.address?.city ?? '',
    state: location.state,
    zipCode: coach?.address?.zipcode ?? '',
    avatar: inferredAvatarUri
      ? {
          uri: inferredAvatarUri,
        }
      : undefined,
  };
};

export const convertMutateCoachFormToCoachUpdate = (
  form: MutateCoachForm,
  existingAddress?: Address,
): Partial<CoachDoc> => {
  return {
    phone: form.phoneNumber,
    address: {
      street1: existingAddress?.street1 ?? null,
      street2: existingAddress?.street2 ?? null,
      country: getCountryName(form.country),
      city: form.city,
      state: form.state,
      zipcode: form.zipCode,
    },
    updated_at: new Date().toISOString(),
  };
};
